<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { SelectContent, type SelectContentProps, SelectScrollUpButton, SelectScrollDownButton, SelectViewport, SelectPortal } from 'reka-ui'
import { cn } from '@/lib/utils'

const props = withDefaults(defineProps<SelectContentProps & { class?: HTMLAttributes['class'] }>(), {
  position: 'popper',
  class: '',
})
</script>

<template>
  <SelectPortal>
    <!-- max-h = the space floating-ui actually measured: a long list near the
         viewport edge shrinks and scrolls (and flip can pick the taller side)
         instead of overflowing off-screen. -->
    <SelectContent
      v-bind="props"
      :class="cn(
        'relative z-50 max-h-[var(--reka-select-content-available-height)] min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        props.class,
      )"
    >
      <SelectScrollUpButton />
      <SelectViewport class="p-1 w-full min-w-[var(--reka-select-trigger-width)]">
        <slot />
      </SelectViewport>
      <SelectScrollDownButton />
    </SelectContent>
  </SelectPortal>
</template>
